module.exports = __webpack_public_path__ + "assets/ed02390f6f21767bdce334275660cbdd.png";